import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  LISTING_DATA_SOURCE_SMART_APARTMENT,
} from 'common/listingConstants';

import {
  TOUR_SHOWING_SOURCE_ADMIN_ADD_TO_TOUR,
} from 'common/tourConstants';

import {
  isSelfShowingListing,
  getListingUrlPath,
} from 'common/listingHelpers';

import SrLink from 'client/components/SrLink/SrLink';

class SrAdminTourCardListingCell extends Component {
  static propTypes = {
    showing: PropTypes.object.isRequired,
    listing: PropTypes.object.isRequired,
  }

  render() {
    const { showing, listing } = this.props;

    return (
      <td className='SrAdminTourCardListingCell listing'>
        <div className='cellContent'>
          {isSelfShowingListing(listing) && (
            <div className='sunlockIcon' />
          )}
          {showing.source === TOUR_SHOWING_SOURCE_ADMIN_ADD_TO_TOUR && (
            <div className='iconAddedByAdmin' />
          )}

          {listing.dataSource === LISTING_DATA_SOURCE_SMART_APARTMENT
            ? (
              <span className='tooltip'>
                {listing.apartmentName}
              </span>
            )
            : ''
          }
          <SrLink to={getListingUrlPath(listing)}>
            {
              `${listing.addressStreetDisplay}, ${listing.addressCity}, ` +
              `${listing.addressStateCode} ${listing.addressZip}`
            }
            {listing.listingManagementCompany && (
              <span className='managementCompany'>{listing.listingManagementCompany}</span>
            )}
          </SrLink>
        </div>
      </td>
    );
  }
}

SrAdminTourCardListingCell.displayName = 'SrAdminTourCardListingCell';

export default SrAdminTourCardListingCell;
